import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Button } from '@workspace/ui/components/Button'
import { Home } from 'lucide-react'

export const Route = createFileRoute('/404')({
    component: NotFoundPage,
})

function NotFoundPage() {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const handleGoHome = () => {
        navigate({ to: '/' })
    }

    return (
        <div className="flex min-h-screen items-center justify-center flex-col p-4 bg-background">
            <div className="w-full max-w-[480px] flex flex-col items-center gap-6 text-center">
                <img src="/404-error.png" alt="Page not found illustration" className="h-full max-h-[360px] w-auto" />

                <div className="space-y-3">
                    <h1 className="text-4xl font-bold text-foreground">{t('notFound.title')}</h1>
                    <p className="text-base text-muted-foreground">{t('notFound.message')}</p>
                </div>

                <Button variant="default" size="lg" onPress={handleGoHome} className="gap-2 mt-2">
                    <Home className="h-4 w-4" />
                    {t('notFound.goHomeButton')}
                </Button>
            </div>
        </div>
    )
}
